// ---------------------------------------------------------------------------
// Section 10: Class — raw className editor (always open)
// ---------------------------------------------------------------------------

import { InspectorSection } from '@/components/inspector'
import { EditableClassField } from '../fields'
import type { CogoElement } from '@/features/page-editor/store/types'

export function ClassSection({
  element,
  updateProp,
}: {
  element: CogoElement
  updateProp: (updates: Partial<CogoElement>) => void
}) {
  if (element.className === undefined) return null

  return (
    <InspectorSection title="Class" defaultOpen>
      <EditableClassField
        value={element.className}
        onChange={(className) => updateProp({ className })}
        elementType={element.type}
      />
    </InspectorSection>
  )
}
